export default {
  setUsers(state, users) {
    state.users = users
  },
  setLoading(state, loading) {
    state.loading = loading
  },
}
